import { EStarTheme } from '../types/star';

export const STAR_FILL_MAP: { [key: string]: string } = {
  [EStarTheme.Filled]: 'var(--accent-warning-primary)',
  [EStarTheme.NotFilled]: '#ced1d7',
};
